export default ($) => {
  $('.js-alert-trigger').on('click', function () {
    $(this).closest('.js-alert-bar').remove();
  })
}